module.exports = __webpack_public_path__ + "img/login-bg.2f5a6339.jpg";